import { usePriceLookup as useSharedPriceLookup } from '@/hooks/use-price-lookup';
import { usePhieuXuatTraLaiNhaCungCapContext } from '../../../context';
import type { DetailRow } from './useDetailRows';

interface PriceLookupResponse {
  gia_nt?: number;
  [key: string]: MuaHangRecord;
}
export function usePriceLookup() {
  const { ngayCt } = usePhieuXuatTraLaiNhaCungCapContext();

  return useSharedPriceLookup<DetailRow, PriceLookupResponse>({
    endpoint: '/erp/purchase-prices/price-lookup/',
    effectiveDate: ngayCt,
    manualPriceFields: ['gia_nt'],
    buildUpdates: ({ response, quantity }) => {
      const gia = Number(response?.gia_nt) || 0;
      const tien = gia * quantity;

      return {
        gia_nt: gia,
        tien_nt: tien
      };
    }
  });
}
